// raw 値のまま export（検証・フォールバックはパッケージ側が使用時に行う）
export const csChatWorkerBaseUrl = process.env.NEXT_PUBLIC_SUNSUN_CHAT_BASE_URL;
